import React, { ReactNode } from 'react';
import {
  SuggestionHeader,
  SuggestionHeaderLabel,
  SuggestionCategoriesContainer,
} from './SuggestionsLayoutTemplate.styles';

interface Props {
  serviceList?: ReactNode;
  practiceList?: ReactNode;
  practitionerList?: ReactNode;
  interestProcedureList?: ReactNode;
  error?: boolean;
}

export const SuggestionsLayoutTemplate = ({
  serviceList,
  practiceList,
  practitionerList,
  interestProcedureList,
  error,
}: Props) => (
  <>
    <SuggestionHeader>
      <SuggestionHeaderLabel error={error}>
        Select a service, practice, practitioner, or specialisation/procedure.
      </SuggestionHeaderLabel>
    </SuggestionHeader>
    <SuggestionCategoriesContainer>
      {serviceList}
      {practiceList}
      {practitionerList}
      {interestProcedureList}
    </SuggestionCategoriesContainer>
  </>
);
